import {ETransactionTrafficType, ETransactionType} from './definitions';

const INIT_RENEWAL_LICENSE_PREFIX =
  'Лицензия на использование Системы edna Pulse с подключением канала';

export default {
  total: 'Итого за период: ',
  loading: 'Загружаем данные',
  allTransactions: 'Списано <0></0>, зачислено <1></1>',
  debit: 'Списано {{value}}',
  credit: 'Зачислено {{value}}',
  th: {
    date: 'Дата',
    dailyStatement: 'Выписка за день',
    createdAt: 'Дата операции',
    amount: 'Сумма',
    description: 'Описание операции',
  },
  filters: {
    title: 'Фильтры',
    reset: 'Очистить',
    credit: 'Зачисления',
    debit: 'Списания',
    allOperations: 'Все операции',
  },
  button: {
    downloadList: 'Выгрузить список',
  },
  listFileName: 'Выписка.xlsx',
  trafficType: {
    [ETransactionTrafficType.SERVICE]: 'Сервисные сообщения',
    [ETransactionTrafficType.AD]: 'Рекламные сообщения',
    [ETransactionTrafficType.MARKETING]: 'Маркетинговые сообщения',
    [ETransactionTrafficType.MULTINAMING]: 'Мультинейминг',
  },
  smsTrafficType: {
    [ETransactionTrafficType.SERVICE]: 'Сервис',
    [ETransactionTrafficType.AUTH]: 'Авторизация',
    [ETransactionTrafficType.INFO]: 'Реклама',
    [ETransactionTrafficType.MRKT]: 'Реклама',
    [ETransactionTrafficType.TEMPLATE_ADV]: 'Реклама',
    [ETransactionTrafficType.ADVERTISEMENT]: 'Реклама',
    [ETransactionTrafficType.AD]: 'Реклама',
    [ETransactionTrafficType.MULTINAMING]: 'Мультинейминг',
  },
  item: {
    statement: 'Выписка по операциям',
    changed: 'Изменено',
    cancelled: 'Отменена:',
    credit: 'Зачислено – {{value}}',
    debit: 'Списано – {{value}}',
    debitTh: {
      type: 'Тип',
      count: 'Количество',
      amount: 'Сумма',
    },
    creditTh: {
      paymentPurpose: 'Назначение платежа',
      amount: 'Сумма',
      invoice: 'Оплата лицензий и услуг',
    },
    number: ' (номер {{channelAttribute}})',
    account: ', учетная запись {{subject}}',
    [ETransactionType.WHATSAPP_AMAU_PAYMENT]: `Переменная часть вознаграждения за Лицензию Системы edna Pulse c функциональностью WA{{account}}{{number}}.`,
    [ETransactionType.WHATSAPP_CONVERSATION_BILLED]: `Услуги по инициации диалогов посредством Системы edna Pulse{{account}}{{number}}. Диалоги`,
    [ETransactionType.WHATSAPP_OUT_MESSAGE_BILLED]: `Услуги по маршрутизации сообщений посредством Системы edna Pulse{{account}}{{number}}`,
    [ETransactionType.WHATSAPP_LICENSE_PAYMENT]: `${INIT_RENEWAL_LICENSE_PREFIX} WhatsApp (MAU {{mauCount}}){{account}}{{number}}, {{month}} {{year}}г.`,
    [ETransactionType.WHATSAPP_CONNECTION_FEE]: `Подключение номера телефона {{number}} MAU {{mauCount}} за {{month}} {{year}} г.`,
    [ETransactionType.SMS_LICENSE_PAYMENT]: `${INIT_RENEWAL_LICENSE_PREFIX} SMS, {{month}} {{year}}г.`,
    [ETransactionType.VIBER_LICENSE_PAYMENT]: `${INIT_RENEWAL_LICENSE_PREFIX} VIBER, {{month}} {{year}}г.`,
    [ETransactionType.MAX_BOT_LICENSE_PAYMENT]: `${INIT_RENEWAL_LICENSE_PREFIX} MAX Bot{{account}}{{number}}, {{month}} {{year}}г.`,
    [ETransactionType.MAX_LICENSE_PAYMENT]: `${INIT_RENEWAL_LICENSE_PREFIX} MAX{{account}}{{number}}, {{month}} {{year}}г.`,
    [ETransactionType.TG_LICENSE_PAYMENT]: `${INIT_RENEWAL_LICENSE_PREFIX} Telegram{{account}}{{number}}, {{month}} {{year}}г.`,
    [ETransactionType.VIBER_OUT_MESSAGE_BILLED]: `Услуги по маршрутизации сообщений посредством Системы edna Pulse{{account}}. {{trafficType}}`,
    [ETransactionType.VIBER_RECURRENT_PAYMENT]: `Минимальный платеж за услуги передачи сообщений Viber за {{month}} {{year}}г.{{account}}`,
    [ETransactionType.SMS_OUT_MESSAGE_BILLED]: `Услуги по маршрутизации сообщений посредством Системы edna Pulse, альфанумерическая подпись {{subject}}. {{trafficType}}`,
    [ETransactionType.SMS_RECURRENT_BILLED]: `Абонентская плата за использование альфанумерической подписи {{subject}}, оператор «{{mobileOperator}}») за {{month}} {{year}}г.`,
    [ETransactionType.SMS_TEMPLATE_BILLED]: `Плата за операторский шаблон SMS ({{templateName}} для подписи {{subject}}, оператор «{{mobileOperator}}») за {{month}} {{year}}г.`,
    [ETransactionType.VIBER_CORRECTION_BILLED]: `Корректировка баланса (учет курсовых разниц)`,
    [ETransactionType.WHATSAPP_CORRECTION_BILLED]: `Корректировка баланса (учет курсовых разниц)`,
    [ETransactionType.PAYKEEPER_PAYMENT]:
      'Аванс по карте за лицензии и услуги {{inn}} {{tenantId}} {{email}}',
    [ETransactionType.PAYKEEPER_FULL_REFUND]:
      'Возврат платежа по карте от {{date}} {{inn}} {{tenantId}} {{email}}',
    [ETransactionType.PAYKEEPER_PARTIAL_REFUND]:
      'Возврат платежа по карте от {{date}} {{inn}} {{tenantId}} {{email}}',
    [ETransactionType.PAYKEEPER_RECURRENT_PAYMENT]: 'Автоплатеж {{inn}} {{tenantId}} {{email}}',
  },
};
